import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { services } from '../mock';
import { ArrowRight } from 'lucide-react';

const Services = () => {
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-sm text-gray-500 uppercase tracking-wider mb-2">Experts in Field</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Our Services</h2>
          <p className="text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Our team of stylists are professionally trained to provide you with excellent hairdressing and hair treatments and our exquisitely designed salons give you a place to unwind.
          </p>
          <p className="text-gray-700 max-w-3xl mx-auto leading-relaxed mt-4">
            We give you a luxurious and premium experience with our exclusively designed chic ambience. You will be in the hands of our expert stylists, who have specialized training.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <Card
              key={service.id}
              className="group hover:shadow-2xl transition-all duration-300 border-0 overflow-hidden"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors duration-300"></div>
              </div>
              <CardContent className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
                <Button
                  variant="link"
                  className="text-black font-semibold p-0 group/btn"
                  onClick={() => document.getElementById('book-appointment')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  Book Appointment
                  <ArrowRight className="ml-2 group-hover/btn:translate-x-1 transition-transform" size={16} />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
